<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box">
      <RequestsPending ref="audioPlayer" />
    </div>

    <div class="user-settings">
      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate"/>
      </button>
    </div>
  </div>
</template>

<script>
import RequestsPending from "@/components/RequestsPending";
export default {
  name: "NavigationBar",
  components: {RequestsPending},
  data() {
    return {
      // Your data properties
    }
  },
  beforeMount() {
    this.checkRequests()
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },
  props: {
    toggle: {
      type: Function,
      require: true
    },
  },
  methods: {
    checkRequests() {
      console.log('Checking requests...');
      return 0;
    },
    syncData() {
      return this.$store.dispatch(`refreshState`);
    },
  }
}
</script>

<style scoped>
.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
</style>
